/****
 * Cropwise SSO Config
 */
const CLIENTIDAUTHCODE_ENC = btoa(
  `${import.meta.env.PA_OAUTH_CLIENT_ID}:${import.meta.env.PA_OAUTH_SECRET}`
);
const O_AUTH_QUERY_PARAMS = {
  responseCode: 'code',
  clientId: import.meta.env.PA_OAUTH_CLIENT_ID
};

export const OAUTH_TOKEN_HEADERS = {
  'Content-Type': 'application/x-www-form-urlencoded',
  authorization: `Basic ${CLIENTIDAUTHCODE_ENC}`
};
const baseURL = import.meta.env.PA_ACCOUNTS_ENDPOINT;

// Use getters to avoid accessing window at module load time
const getOrigin = () => (typeof window !== 'undefined' ? window.location.origin : '');

export const getSSO_LOGIN_URL = () =>
  `https://${baseURL}/oauth/authorize?response_type=${O_AUTH_QUERY_PARAMS.responseCode}&client_id=${O_AUTH_QUERY_PARAMS.clientId}&redirect_uri=${getOrigin()}`;

export const getSSO_LOGOUT_URL = () => `https://${baseURL}/exit?continue=${getOrigin()}`;

// Maintain backward compatibility - these will be empty strings in test environment
export const SSO_LOGIN_URL = getSSO_LOGIN_URL();
export const SSO_LOGOUT_URL = getSSO_LOGOUT_URL();
